// @TODO: Replace hex values with theme variables once they are available - https://ecosystem.atlassian.net/browse/MC-4749
export const trustSignals = [{
  id: 'app-count',
  stats: '16K +',
  label: 'Apps on marketplace',
  cardStyles: {
    backgroundColor: '#F8EEFE'
  },
  statsStyles: {
    color: '#BF63F3'
  }
}, {
  id: 'partner-count',
  stats: '5K +',
  label: 'Active partners',
  cardStyles: {
    backgroundColor: '#EFFFD6'
  },
  statsStyles: {
    color: '#82B536'
  }
}, {
  id: 'customer-count',
  stats: '50K +',
  label: 'Happy Customers',
  cardStyles: {
    backgroundColor: '#FFF8E3'
  },
  statsStyles: {
    color: '#FFA900'
  }
}, {
  id: 'partner-revenue',
  stats: '$3m +',
  label: 'Revenue for partners',
  cardStyles: {
    backgroundColor: '#E7F9FF'
  },
  statsStyles: {
    color: '#42B2D7'
  }
}];